import { render, staticRenderFns } from "./JdsTimestamp.vue?vue&type=template&id=74f6af8d&"
import script from "./JdsTimestamp.vue?vue&type=script&lang=ts&"
export * from "./JdsTimestamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports